import {
  BackOutWorkOrderData,
  TimelinessWorkOrderData,
} from './types/reliabilityScore.type';
import {
  TIME_FORMAT_CONSTANTS,
  BACKOUT_CONSTANTS as BackoutConstants,
  BACKOUT_TYPE_TO_CLASS_MAP,
  TIMELINESS_TYPE_TO_CLASS_MAP as TimelinessTypeToClassMap,
} from './config';

import { dateStringToLocalTime, dateToLocalMoment } from '../../../MessageContainer/util';
import { UserGroups } from '../../../ProfileSettings/constants';

export const convertToDate = (dateString?: string) => {
  if (!dateString) {
    return BackoutConstants.MESSAGES.NO_DATE;
  }
  return new Date(dateString).toLocaleDateString(
    BackoutConstants.DATE_FORMAT.LOCALE,
    BackoutConstants.DATE_FORMAT.OPTIONS,
  );
};

export const getTypeClass = (type: BackOutWorkOrderData['type']) => BACKOUT_TYPE_TO_CLASS_MAP[type] || '';

export const getTimelinessTypeClass = (type: TimelinessWorkOrderData['type']) => TimelinessTypeToClassMap[type] || '';

export const nounPostFixGenerator = (
  targetNum: number,
  unit: string,
  isCheck0 = false,
  separator = ' ',
): string => {
  if (targetNum === 1) {
    return `${targetNum}${separator}${unit}`;
  }
  if (targetNum > 1) {
    return `${targetNum}${separator}${unit}s`;
  }
  if (isCheck0 && targetNum === 0) {
    return `${targetNum}${separator}${unit}s`;
  }
  return '';
};

export const getCheckInTime = (item: TimelinessWorkOrderData) => {
  const arrivalTime = dateToLocalMoment(item?.arrivalTime?.utc);
  const checkedInAt = dateToLocalMoment(item?.checkedInAt?.utc);
  const diff = checkedInAt.diff(arrivalTime, TIME_FORMAT_CONSTANTS.UNIT_NAMES.DAYS);
  const localCheckedIn = dateStringToLocalTime(item?.checkedInAt?.utc, TIME_FORMAT_CONSTANTS.TIME_12_HOUR);
  const day = nounPostFixGenerator(diff, TIME_FORMAT_CONSTANTS.UNIT_NAMES.DAY);
  const checkedIn = diff > 0 ? `${localCheckedIn}${TIME_FORMAT_CONSTANTS.DATE_SEPARATOR}${day}` : localCheckedIn;
  return checkedIn;
};

export const adjustTextForTableWidth = (
  text: string,
  maxWidth: number,
  charWidth = 3,
  ellipsis = true,
): string => {
  if (!text || maxWidth <= 0) {
    return '';
  }

  const maxChars = Math.floor(maxWidth / charWidth);
  const maxCharsWithEllipsis = maxChars - 3;
  const ellipsisLabel = '...';

  if (text.length <= maxChars) {
    return text;
  }

  if (ellipsis && maxCharsWithEllipsis > 3) {
    return `${text.substring(0, maxCharsWithEllipsis)}${ellipsisLabel}`;
  }

  return text.substring(0, maxChars);
};

export const isMyOwnProfile = (providerId = 0): boolean => window?.context?.id === providerId;

export const isStaff = [UserGroups.ACCOUNTANT, UserGroups.STAFF].includes(Number(window?.context?.group?.id ?? 0));
